import { LogLevel } from "@shopliftr/common-ng";
import { environment as baseConfig } from "./environment.base";
import { IAppConfig } from "../app/common/interfaces/app-config";

export const environment: IAppConfig = {
    ...baseConfig,
    production: true,
    staging: false,
    apiUrl: "https://internal-api.mygrocerydeals.com",
    rollbar: {
        level: LogLevel.Error,
        environment: "production",
        accessToken: "545c6946038844aeb7b0335520063529"
    },
    newrelic: {
        enabled: false,
        trackRouteChanges: false,
        logLevel: LogLevel.Off
    },
    authentication: {
        ...baseConfig.authentication,
        logins: []
    },
    displayUncaughtErrorMessage: false
};
